import React, { Component } from 'react';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import URLParse from 'url-parse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTachometerAlt, faMapMarkerAlt, faUsers, faGamepad, faFolderOpen, faBell, faBook, faCalendar, faCalendarDay, faCalendarCheck, faCalendarAlt, faHome, faUserCog, faDoorClosed, faDoorOpen, faCog } from '@fortawesome/free-solid-svg-icons';
import GeneralHelper from '../../helpers/general';

const { SubMenu } = Menu;
const { Sider } = Layout;

const rootSubmenuKeys = ['sub-controllers', 'sub-locations', 'sub-system-users', 'sub-reports'];

export class Drawer extends Component {
	state = {
		openKeys: [],
		collapsed: false,
		windowWidth: window.innerWidth
	};

	componentDidMount() {
		this.getActiveSubmenu();
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	handleResize = () => {
		this.setState({
			windowWidth: window.innerWidth
		});
	};

	getActiveItem({ pathname, search }) {
		switch (true) {
			case /\/bookings/.test(pathname):
				return ['bookings'];
			case /\/account/.test(pathname):
				return ['account'];
			case /\/calendar/.test(pathname):
				return ['calendar'];
			default:
				return;
		}
	}

	getActiveSubmenu() {
		const pathname = this.props.location.pathname;
		switch (true) {
			case /\/bookings/.test(pathname) || /\/calendar/.test(pathname):
				this.setState({
					openKeys: ['sub-bookings']
				});
				break;
			default:
				break;
		}
	}

	onOpenChange = keys => {
		const latestOpenKey = keys.find(key => this.state.openKeys.indexOf(key) === -1);
		if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
			this.setState({
				openKeys: keys
			});
		} else {
			this.setState({
				openKeys: latestOpenKey ? [latestOpenKey] : []
			});
		}
	};

	render() {
		const activeItem = this.getActiveItem({
			pathname: this.props.location.pathname,
			search: this.props.location.search
		});
		const { collapsed } = this.props;
		const { windowWidth } = this.state;

		return (
			<Sider
				trigger={null}
				collapsible
				collapsedWidth={windowWidth < 600 ? 0 : 60}
				collapsed={collapsed}
				width="256"
				className="nav-sider"
				breakpoint="md"
				onCollapse={this.props.handleOnCollapse}
			>
				<div className={collapsed && windowWidth >= 600 ? 'menu-logo-notext' : 'menu-logo'} />
				<Menu
					theme="dark"
					mode="inline"
					openKeys={this.state.openKeys}
					onOpenChange={this.onOpenChange}
					selectedKeys={activeItem}
				>
					<Menu.Item key="bookings">
						<FontAwesomeIcon
							icon={faCalendarCheck}
							fixedWidth
						/>
						<span style={collapsed ? { marginLeft: 10, display: 'none' } : { marginLeft: 10 }}>Bookings</span>
						<Link to="/bookings" />
					</Menu.Item>
					<Menu.Item key="calendar">
						<FontAwesomeIcon
							icon={faCalendarAlt}
							fixedWidth
						/>
						<span style={collapsed ? { marginLeft: 10, display: 'none' } : { marginLeft: 10 }}>Calendar</span>
						<Link to="/calendar" />
					</Menu.Item>
					<Menu.Item key="account">
						<FontAwesomeIcon
							icon={faCog}
							fixedWidth
						/>
						<span style={collapsed ? { marginLeft: 10, display: 'none' } : { marginLeft: 10 }}>Account Settings</span>
						<Link to="/account" />
					</Menu.Item>
				</Menu>
			</Sider>
		);
	}
}

export default Drawer;
